import { render, staticRenderFns } from "./NewFloorForm.vue?vue&type=template&id=371c8baa&scoped=true&"
import script from "./NewFloorForm.vue?vue&type=script&lang=js&"
export * from "./NewFloorForm.vue?vue&type=script&lang=js&"
import style0 from "./NewFloorForm.vue?vue&type=style&index=0&id=371c8baa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371c8baa",
  null
  
)

export default component.exports